// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","HasSeen":"cl_a bhe_fg bhe_up bhe_vz bhe_h"};